import { Component, HostListener } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/public/services/auth.service';
import { JWTTokenServiceService } from 'src/app/public/services/token.service';
import { LocalStorageService } from 'src/app/utils/LocalStorageService';
import { MessageService, SharedModule } from 'primeng/api';
import { CommonModule } from '@angular/common';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { MessageModule } from 'primeng/message';
import { InputTextModule } from 'primeng/inputtext';
import { FloatLabel } from 'primeng/floatlabel';
import { IconFieldModule } from 'primeng/iconfield';
import { InputIconModule } from 'primeng/inputicon';
import { InputOtpModule } from 'primeng/inputotp';
import { ToastModule } from 'primeng/toast';
@Component({
  selector: 'app-login',
  imports: [CommonModule, ReactiveFormsModule, FormsModule, MessageModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    InputTextModule,
    InputIconModule,
    IconFieldModule,
    InputOtpModule,
    ToastModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
  providers: [MessageService]
})
export class LoginComponent {
  userName: any;
  btnLoading: boolean = false;
  isPasswordVisible: boolean = false;
  form: FormGroup = new FormGroup({
    username: new FormControl(''),
    password: new FormControl(''),
  });
  submitted = false;
  isLoading = false;
  buttonTitle = "Login"
  otpForm: boolean = false;
  userOTP: any;
  loginData: any;
  constructor(private messageService: MessageService, private localStorageService: LocalStorageService, private coreAuth: AuthService, private router: Router, private formBuilder: FormBuilder, private jwt: JWTTokenServiceService) { }
  @HostListener('window:keyup', ['$event'])
  keyEvent(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      this.onEnter();
    }
  }

  onEnter() {
    if (this.otpForm) {
      this.onOTPLogin();
    } else {
      this.onSubmit();
    }
  }
  ngOnInit(): void {
    this.form = this.formBuilder.group(
      {
        username: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(20)]],
        password: ['', [Validators.required, Validators.minLength(6), Validators.maxLength(40)]],
      }
    );
  }


  forgetPassword() {
    this.router.navigate(['forget-password']);
  }
  goToDashboard() {
    this.router.navigate(['dashboard/home']);
  }


  get formError(): any {
    return this.form.controls;
  }
  onOTPLogin() {
    this.submitted = true;
    this.isLoading = true;
    this.buttonTitle = "Loading..."
    let param = {
      user_id: this.loginData.user_id,
      otp: this.userOTP,
      token: this.loginData.token

    }
    this.coreAuth.verifyOtp(param).subscribe({
      next: (res: any) => {
        if (res) {
          this.buttonTitle = "Login"
          this.isLoading = false;
          this.jwt.setToken(res.token);
          // this.toastr.success('Login Successful', 'Welcome');
          this.messageService.add({
            severity: 'success',
            summary: 'Login Successful',
            detail: 'Welcome'  // Similar to toastr.success
          });
          this.localStorageService.login(res);
          this.router.navigate(['main/leads']);
        }

      },
      error: (e) => {
        console.log(e);
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid OTP',
          detail: 'Please enter correct OTP'  // Similar to toastr.error
        });
        this.buttonTitle = "Login"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      }
    })
  }

  onSubmit(): void {
    this.submitted = true;
    if (this.form.invalid) {
      return;
    }
    this.isLoading = true;
    this.buttonTitle = "Loading..."
    const formValue = {
      username: this.form.value.username?.trim() || '',
      password: this.form.value.password?.trim() || ''
    };
    this.coreAuth.loginUser(formValue).subscribe({
      next: (res: any) => {
        if (res) {
          if (res.twoFactorAuthentication) {
            // this.toastr.success("OTP has been sent to your registered email ID. Please check your inbox.")
            this.messageService.add({
              severity: 'success',
              summary: 'OTP Sent',
              detail: 'OTP has been sent to your registered email ID. Please check your inbox.'  // Similar to toastr.success
            });
            this.otpForm = true;
            this.loginData = res;
          }
          else {
            console.log(" i a logged in");
            this.buttonTitle = "Login"
            this.isLoading = false;
            this.jwt.setToken(res.token);
            this.messageService.add({
              severity: 'success',
              summary: 'Login Successful',
              detail: 'Welcome'  // Similar to toastr.success
            });
            this.localStorageService.login(res);

            if(res?.studentProfileMode && res?.studentProfileMode == true){
              this.router.navigate(['main/student/stage/profile']);
              return;
            }

            if(res.organization_id && res.organization_id == "7"){
              // redirect to campaign page
              this.router.navigate(['main/manage-campaign']);
              return;
            }

            this.router.navigate(['main/leads']);
          }

        }

      },
      error: (e) => {
        this.messageService.add({
          severity: 'error',
          summary: 'Invalid Credentials',
          detail: 'Error'  // Similar to toastr.error
        });
        this.buttonTitle = "Login"
        this.isLoading = false;
      },
      complete: () => {
        this.buttonTitle = "Login"
        this.isLoading = false;
      }
    })
  }
  forgetPass() {
    this.router.navigate(['forget']);
  }
}
